<ng-container *transloco="let t">
    <form>
        <div
            class="top-search-bar"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="start start"
            fxFlexFill
        >
            <mat-form-field
                appearance="outline"
                class="search"
                fxFlex="50"
                fxFlex.lt-md="100"
                fxFlexFill
                subscriptSizing="dynamic"
            >
                <mat-icon matPrefix>search</mat-icon>
                <input
                    matInput
                    name="searchText"
                    [placeholder]="t('provider.search-area.form.search-text')"
                    [(ngModel)]="searchParams.searchText"
                    aria-label="Search by name
                or description"
                />
                <a (click)="clearProviderSearch()" matSuffix aria-label="Clear">
                    <mat-icon
                        *ngIf="
                            searchParams.searchText !== null &&
                            searchParams.searchText !== ''
                        "
                        >close</mat-icon
                    >
                </a>
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="place"
                fxFlex="45"
                fxFlex.lt-md="100"
                fxFlexFill
                subscriptSizing="dynamic"
            >
                <mat-icon matPrefix>place</mat-icon>
                <input
                    matInput
                    name="address"
                    [placeholder]="t('provider.search-area.form.address')"
                    [(ngModel)]="searchParams.address"
                    aria-label="Search by city or postal code"
                />
                <a (click)="clearAddress()" matSuffix aria-label="Clear">
                    <mat-icon
                        *ngIf="
                            searchParams.address !== null &&
                            searchParams.address !== ''
                        "
                        >close</mat-icon
                    >
                </a>
            </mat-form-field>

            <button
                mat-icon-button
                type="submit"
                class="search-button"
                (click)="search()"
                fxFlex="5"
                fxFlex.lt-md="100"
                fxFlexFill
                aria-label="Search button"
            >
                <mat-icon fxHide.lt-md>refresh</mat-icon>
                <mat-icon fxHide.gt-sm>search</mat-icon>
            </button>
        </div>
        <div
            class="program-and-distance-search"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="start start"
        >
            <mat-form-field
                appearance="outline"
                class="padding-0"
                fxFlex="50"
                fxFlex.lt-md="100"
                fxFlexFill
                subscriptSizing="dynamic"
            >
                <mat-select
                    [(value)]="selectedPrograms"
                    [formControl]="programsControl"
                    (selectionChange)="search()"
                    name="programs"
                    multiple
                    [placeholder]="
                        t('provider.search-area.form.select-programs')
                    "
                >
                    <mat-option
                        *ngFor="let program of programs"
                        [value]="program"
                    >
                        {{ program.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                class="padding-0"
                fxFlex="50"
                fxFlex.lt-md="100"
                fxFlexFill
                subscriptSizing="dynamic"
            >
                <mat-select
                    [(value)]="distanceSearch"
                    (selectionChange)="search()"
                    [placeholder]="
                        t('provider.search-area.form.distance.title')
                    "
                >
                    <mat-option value="0">
                        {{
                            t(
                                "provider.search-area.form.distance.options.show-all"
                            )
                        }}
                    </mat-option>
                    <mat-option value="5">
                        {{
                            t(
                                "provider.search-area.form.distance.options.within-x-miles",
                                { distance: 5 }
                            )
                        }}
                    </mat-option>
                    <mat-option value="10">
                        {{
                            t(
                                "provider.search-area.form.distance.options.within-x-miles",
                                { distance: 10 }
                            )
                        }}
                    </mat-option>
                    <mat-option value="25">
                        {{
                            t(
                                "provider.search-area.form.distance.options.within-x-miles",
                                { distance: 25 }
                            )
                        }}
                    </mat-option>
                    <mat-option value="50">
                        {{
                            t(
                                "provider.search-area.form.distance.options.within-x-miles",
                                { distance: 50 }
                            )
                        }}
                    </mat-option>
                    <mat-option value="100">
                        {{
                            t(
                                "provider.search-area.form.distance.options.within-x-miles",
                                { distance: 100 }
                            )
                        }}
                    </mat-option>
                    <mat-option value="250">
                        {{
                            t(
                                "provider.search-area.form.distance.options.within-x-miles",
                                { distance: 250 }
                            )
                        }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div
            class="selected-programs"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <mat-chip-listbox class="program-chips">
                <mat-chip-option
                    class="program-chip"
                    *ngFor="let program of selectedPrograms; let i = index"
                    removable="true"
                    (removed)="removeProgram(i)"
                >
                    {{ program.name }}
                    <mat-icon class="program-chip-remove" matChipRemove
                        >cancel</mat-icon
                    >
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
    </form>
</ng-container>
